import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import { useContext } from 'react'
import { TextFieldInputNumber, parseFloatCheckValue } from '../Ticket/fnTickit';
import { ProviderExpensePlan } from './FundExpensesPlanForm';
import InputReactNumber from '../InputReactNumber';

const TableInputTotal = (props) => {
    const { keyCellMuseum, item } = props;

    const {
        isVersion,
        isView
    } = useContext(ProviderExpensePlan);

    const handleChangeValue = (eValue) => {
        item.nTotalInput = parseFloatCheckValue(eValue);
    }

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                วงเงินทั้งหมด<span className='red'>*</span>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <TableContainer id='table-receive' component={Paper}>
                    <Table >
                        <TableBody>
                            <TableRow>
                                <TableCell padding='none' align='center' style={{ minWidth: '100px', width: '100px' }}>จำนวนเงิน </TableCell>
                                <TableCell padding='none' >
                                    {
                                        isVersion ?
                                            <TextFieldInputNumber value={item.nTotalInput} digit={2} />
                                            :
                                            <InputReactNumber   //InputReactNumber      //InputNumberIncomeExpense
                                                id={keyCellMuseum}
                                                name={keyCellMuseum}
                                                defaultValue={item.nTotalInput}
                                                required={true}
                                                disabled={isView || isVersion}
                                                maxInteger={20}
                                                IsCanMinus={false}
                                                IsShowMessageError={false}
                                                onChange={(eValue) => handleChangeValue(eValue)}
                                            />
                                    }

                                </TableCell>
                                <TableCell padding='none' align='center' style={{ minWidth: '50px', width: '50px' }}>บาท</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    )
}

export default TableInputTotal